export async function addItemToCart({
  variantId,
  quantity,
  countryCode,
}: {
  variantId: string
  quantity: number
  countryCode: string
}): Promise<void> {
  const res = await fetch("/api/cart/add-item", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({ variantId, quantity, countryCode }),
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) {
    throw new Error(data.error || "Failed to add item to cart")
  }
}

export async function saveCheckoutAddresses(formData: FormData): Promise<void> {
  const res = await fetch("/api/checkout/addresses", {
    method: "POST",
    body: formData,
    credentials: "same-origin",
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) {
    throw new Error(data.error || "Failed to save address")
  }
}

import { PAYPAL_UNSUPPORTED_REGION_CODE } from "@/lib/checkout/paypal"
import { STRIPE_MIN_AMOUNT_CODE } from "@/lib/checkout/stripe"

export async function initiateCheckoutPayment(providerId: string): Promise<void> {
  const res = await fetch("/api/checkout/payment-session", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({ provider_id: providerId }),
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) {
    if (
      data.code === PAYPAL_UNSUPPORTED_REGION_CODE ||
      data.error === PAYPAL_UNSUPPORTED_REGION_CODE
    ) {
      throw new Error(PAYPAL_UNSUPPORTED_REGION_CODE)
    }
    if (
      data.code === STRIPE_MIN_AMOUNT_CODE ||
      data.error === STRIPE_MIN_AMOUNT_CODE
    ) {
      throw new Error(STRIPE_MIN_AMOUNT_CODE)
    }
    throw new Error(data.error || "Failed to start payment session")
  }
}

export async function placeCheckoutOrder(): Promise<any> {
  const res = await fetch("/api/checkout/place-order", {
    method: "POST",
    credentials: "same-origin",
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) {
    throw new Error(data.error || "Failed to place order")
  }
  return data
}
